/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import { createReducer } from '@reduxjs/toolkit';
import {
    getOrderRequest,
    getOrderSuccess,
    getOrderFailed,
    getOrderClear,
    getOrderDetailsSuccess,
} from '../actions';
import { TOrderData, TwsOrder } from '../../utils/types';

export type TOrderInitialState = {
    isLoading: boolean;
    hasError: boolean;
    data: null | TOrderData;
    error: null | string;
    details: null | TwsOrder;
};

const initialState: TOrderInitialState = {
    isLoading: false,
    hasError: false,
    data: null,
    error: null,
    details: null,
};

export const orderReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(getOrderRequest, (state) => {
            state.isLoading = true;
        })
        .addCase(getOrderSuccess, (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        })
        .addCase(getOrderFailed, (state) => {
            state.isLoading = false;
            state.hasError = true;
            state.data = null;
        })
        .addCase(getOrderClear, (state) => {
            state.data = null;
        })
        .addCase(getOrderDetailsSuccess, (state, action) => {
            state.details = action.payload;
        });
});

export default orderReducer;
